import styled from 'styled-components';
import { IPOStyleMixins } from '../../../styles';
export const NavWrap = styled.div`
	${IPOStyleMixins.flex('flex', 'flex-start', 'center')}
	background: #fff;
	> div {
		cursor: pointer;
		margin-right: 50px;
		box-shadow: 0px 4px 20px 0px rgba(23, 43, 77, 0.18);
		border-radius: 10px;
		padding: 17px 20px;
		.num {
			color: #fff;
			font-size: 32px;
			font-weight: 500;
			${IPOStyleMixins.flex('flex', 'space-between', 'center')}
			div:nth-child(1) {
				margin-right: 55px;
			}
			> img {
				width: 26px;
				height: 24px;
			}
		}
		.content {
			margin-top: 10px;
			font-size: 14px;
			font-weight: 400;
			color: rgba(255, 255, 255, 0.5);
		}
	}
	> div:nth-child(1) {
		background: #0040e1;
	}
	> div:nth-child(2) {
		background: #436bff;
	}
	> div:nth-child(3) {
		background: #6d76ff;
	}
`;
